import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'dateFormat',
  standalone: true
})
export class DateFormatPipe implements PipeTransform {
  transform(value: any, format: string = 'mediumDate'): string {
    if (!value) return '';
    
    // Handle Firestore Timestamp
    const date = value.toDate ? value.toDate() : new Date(value);
    
    return formatDate(date, format, 'en-US');
  }
}
